export default "<div class=\"map\" id=\"mapViewDiv\"></div>";